import { Observable } from 'rxjs';
import { ReportDefinitionBase, ReportGenerateRequest } from './model';

export abstract class AccountingReportsRepository {
  abstract getAvailableReports(): Observable<ReportDefinitionBase[]>;
  abstract generateReport(request: ReportGenerateRequest): Observable<string>; // Returns XML as string
  abstract saveDailyClosure(data: any): Observable<any>;
}
